import '../index.css'
import useSWR from 'swr';
import { fetcher } from "../lib/fetcher.js";
import { useSearchParams } from "react-router-dom"

function OSATable() {
    const [searchParams] = useSearchParams()
    const password = searchParams.get("password")

    const { data } = useSWR(
        true
            ? `/api/osa?password=${password}`
            : null,
        fetcher
    )
    const osa = data?.data || [];

    return (
        <div className='home-main'>
            <table border="1" cellPadding="8">
                <thead>
                    <tr>
                        <th>Namn</th>
                        <th>Kommer</th>
                        <th>Allergier</th>
                        <th>Datum</th>
                    </tr>
                </thead>

                <tbody>
                    {osa.map((person, i) => (
                        <tr key={i}>
                            <td>{person.firstname + " " + person.surname}</td>
                            <td>{person.coming ? "Ja" : "Nej"}</td>
                            <td>
                                {Array.isArray(person.allergies)
                                    ? person.allergies.join(", ")
                                    : person.allergies}
                            </td>
                            <td>{new Date(person.created_at).toLocaleString()}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default OSATable;
